
    import './styles.scoped.css';
    export default {
  "icon-swap-copy": "awsui_icon-swap-copy_5a145_18twf_9",
  "icon-swap-result": "awsui_icon-swap-result_5a145_18twf_26",
  "icon-swap-copied": "awsui_icon-swap-copied_5a145_18twf_43",
  "root": "awsui_root_5a145_18twf_77",
  "icon-swap": "awsui_icon-swap_5a145_18twf_9",
  "icon-swap-success": "awsui_icon-swap-success_5a145_18twf_115",
  "icon-swap-error": "awsui_icon-swap-error_5a145_18twf_119",
  "popover-message": "awsui_popover-message_5a145_18twf_123",
  "inline-container": "awsui_inline-container_5a145_18twf_127",
  "inline-container-trigger": "awsui_inline-container-trigger_5a145_18twf_130",
  "inline-container-no-wrap": "awsui_inline-container-no-wrap_5a145_18twf_133",
  "text-to-display": "awsui_text-to-display_5a145_18twf_142"
};
  